var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.source === 'ShowFileComponent' ? 'video-player-container-normal' : 'video-player-container-online-class'},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-fill",attrs:{"crossorigin":"anonymous"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }